import {create_title} from '@/base/titleData'
import {
  basic_nleavemessage_new_style
} from '@/base/widgets_data_compatible';
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    title: create_title('Form'),
    //表单名称
    form_title: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fsWeight: 'normal',
        fontSize: 18,
        fontColor:'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 18,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      }
    },
    //表单项名称
    form_item_title: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fsWeight: 'normal',
        fontSize: 14,
        fontColor:'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 14,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      }
    },
    //表单项内容
    form_item_content: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fsWeight: 'normal',
        fontSize: 14,
        fontColor:'rgba(51,51,51,1)',
        enterColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 14,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        enterColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 0
        },
      }
    },
    ...basic_nleavemessage_new_style()
  },
  mb_widgets_infor: {
    title: create_title('Form')
  },
  listArr: {
    moduleStyle: 0,
    id: ''
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_nleavemessage/style.js